import { WidgetProps } from '@rjsf/utils';

export const ShowAdvancedButton = (props: WidgetProps) => {
  const { value: formValue, onChange, options } = props;
  const fieldsLabel = (options?.fieldsLabel as string | undefined) || 'Advanced Fields';

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const newVal = !formValue;
    onChange(newVal);
  };

  if (props.readonly) return null;

  return (
    <button
      type="button"
      className="px-4 py-2 bg-indigo-light text-grey-8"
      onClick={handleClick}>
      {`${formValue ? 'Hide' : 'Show'} ${fieldsLabel}`}
    </button>
  );
};
